import React, { useEffect, useState } from "react";
import { columns } from "./tableColumns";
import CustomTable from "../../../../../components/Table/CustomTable";
import Loader from "../../../../../components/Loader";
import { useCustomParams } from "../../../../../hooks/useCustomParams";
import { useClientBuildings } from "../../../../../reactQuery/building";
import { useParams } from "react-router-dom";
import { Box, Divider } from "@mui/material";
import { useDispatch } from "react-redux";
import { setBuildingStats } from "../../../../../redux/buildingStatsSlice";
import { useSelector } from "react-redux";

function Table() {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [search] = useCustomParams("search");
   const [client] = useCustomParams("client");
  const params = useParams();
  const dispatch = useDispatch();

  const {
    isLoading,
    error,
    responseData,
    isError,
    refetch,
    totalRecords,
    totalUnits,
  } = useClientBuildings(
    {
      page: page + 1,
      pageSize,
      search,
      clientId: params.clientId || client,
      pagination: true,
    },
    params.clientId || client
  );

  useEffect(() => {
    refetch();
  }, [params.clientId, page, pageSize, search, client]);

  useEffect(() => {
    if (!isLoading && !isError && totalRecords !== undefined && totalUnits !== undefined) {
      dispatch(setBuildingStats({
        totalUnits,
        totalRecords,
      }));
    }
  }, [isLoading, isError, totalUnits, totalRecords, dispatch]);

  return (
    <>
      {isLoading && (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      )}
      {!isLoading && isError && (
        <div className="loader-center">
          <p>{error?.response?.data?.message || "Error"}</p>
        </div>
      )}
      {!isLoading && !isError && (
        <>
          <CustomTable
            initialRows={responseData}
            columns={columns}
            headerBgColor={"#F5F5F9"}
            rowCount={totalRecords}
            defaultSort={"address"}
            setPaginationModel={(data) => {
              setPage(data.page);
              setPageSize(data.pageSize);
            }}
            page={page}
            pageSize={pageSize}
            subHeight={282}
            // hideFooter={true}
            borderRadius={false}
            useMaxHeight={true}
          />
          {/* <div className="table-bottom">
            <Box className="d-flex">
              <Box className="mr-4">
                <p className="bottom-detail">{responseData.length} Buildings</p>
              </Box>

              <Divider orientation="vertical" flexItem />

              <Box className="ml-4">
                <p className="bottom-detail">
                  {totalUnits} Units
                </p>
              </Box>
            </Box>
          </div> */}
        </>
      )}
    </>
  );
}

export default Table;
